import { ADDRESS_ZERO } from "../address";
import { DEFAULT_PROTOCOL_KEY } from "../constants";
import { DEFAULT_CHAIN_KEY } from "../chain-legacy";
import { SKELETON_TOKEN_NAME, SKELETON_TOKEN_SYMBOL } from "../token";
import { USD_ZERO } from "../usd";
import { PERCENT_ZERO } from "../percent";
import { MarketAsset } from "./market-asset";

export type DisplayMarketAsset = typeof DisplayMarketAsset.Type;
export type DisplayMarketAssetEncoded = typeof DisplayMarketAsset.Encoded;

export const DisplayMarketAsset = MarketAsset.pick(
  "protocolKey",
  "chainKey",
  "tokenAddress",
  "symbol",
  "name",
  "decimals",

  "liquidityUsd",
  "tvlUsd",
  "collateralBaseApr",
  "collateralRewardsApr",
  "collateralMerklRewards",
  "collateralPoints",
  "protectedRewardsApr",
  "protectedMerklRewards",
  "protectedPoints",
  "debtBaseApr",
  "debtRewardsApr",
  "debtMerklRewards",
  "debtPoints",

  "isDebtAprFixed",

  "depositMode",

  "depositTotalApr",
  "debtTotalApr"
).annotations({ identifier: "DisplayMarketAsset" });

export const SKELETON_DISPLAY_MARKET_ASSET: DisplayMarketAsset = {
  protocolKey: DEFAULT_PROTOCOL_KEY,
  chainKey: DEFAULT_CHAIN_KEY,
  tokenAddress: ADDRESS_ZERO,
  symbol: SKELETON_TOKEN_SYMBOL,
  name: SKELETON_TOKEN_NAME,
  decimals: 18,

  liquidityUsd: USD_ZERO,
  tvlUsd: USD_ZERO,
  collateralBaseApr: PERCENT_ZERO,
  collateralRewardsApr: PERCENT_ZERO,
  collateralMerklRewards: [],
  collateralPoints: [],
  protectedRewardsApr: PERCENT_ZERO,
  protectedMerklRewards: [],
  protectedPoints: [],
  debtBaseApr: PERCENT_ZERO,
  debtRewardsApr: PERCENT_ZERO,
  debtMerklRewards: [],
  debtPoints: [],

  isDebtAprFixed: false,

  depositMode: "defaultTrue",

  depositTotalApr: PERCENT_ZERO,
  debtTotalApr: PERCENT_ZERO,
};
